const CriticReview = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.64533 2.65211C8.71892 2.4049 9.06604 2.39676 9.15113 2.64026L10.4171 6.26307C10.4692 6.41216 10.5887 6.52787 10.7394 6.57517L14.1519 7.64644C14.3939 7.72241 14.4022 8.06185 14.1642 8.14956L10.7164 9.42022C10.5791 9.47084 10.4708 9.57912 10.4202 9.71647L9.1495 13.1643C9.06179 13.4023 8.72235 13.394 8.64638 13.152L7.57511 9.73946C7.52781 9.58878 7.4121 9.4693 7.26301 9.4172L3.6402 8.15119C3.3967 8.0661 3.40484 7.71898 3.65205 7.64539L7.24057 6.5772C7.40239 6.52904 7.52898 6.40245 7.57714 6.24063L8.64533 2.65211Z"
      stroke="#444444"
    />
    <path
      d="M3.1347 1.6042C3.22352 1.4088 3.50106 1.4088 3.58988 1.6042L4.17778 2.89758C4.2078 2.96362 4.26072 3.01654 4.32675 3.04655L5.62013 3.63445C5.81553 3.72327 5.81553 4.00082 5.62013 4.08964L4.32675 4.67754C4.26072 4.70755 4.2078 4.76047 4.17778 4.82651L3.58988 6.11989C3.50106 6.31529 3.22352 6.31529 3.1347 6.11989L2.5468 4.82651C2.51678 4.76047 2.46386 4.70755 2.39783 4.67754L1.10445 4.08964C0.909047 4.00082 0.909047 3.72327 1.10445 3.63445L2.39783 3.04655C2.46386 3.01654 2.51678 2.96362 2.5468 2.89758L3.1347 1.6042Z"
      fill="#444444"
    />
    <path
      d="M4.66425 11.1919C4.72896 11.0495 4.93119 11.0495 4.99591 11.1919L5.37777 12.032C5.41175 12.1067 5.47166 12.1667 5.54642 12.2006L6.38652 12.5825C6.52889 12.6472 6.52889 12.8494 6.38652 12.9142L5.54642 13.296C5.47166 13.33 5.41175 13.3899 5.37777 13.4647L4.99591 14.3048C4.93119 14.4471 4.72896 14.4471 4.66425 14.3048L4.28239 13.4647C4.24841 13.3899 4.18849 13.33 4.11374 13.296L3.27363 12.9142C3.13126 12.8494 3.13126 12.6472 3.27363 12.5825L4.11374 12.2006C4.18849 12.1667 4.24841 12.1067 4.28239 12.032L4.66425 11.1919Z"
      fill="#444444"
    />
  </svg>
);

export default CriticReview;
